import { render } from "./ModuleBoardDecisions.vue?vue&type=template&id=3c44ea99"
import script from "./ModuleBoardDecisions.vue?vue&type=script&lang=js"
export * from "./ModuleBoardDecisions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__